import { useState, useEffect } from 'react';
import supabase from '../supabase';

export function useCreatorSearch() {
    const [searchQuery, setSearchQuery] = useState('');
    const [creators, setCreators] = useState([]);
    const [searchResults, setSearchResults] = useState([]);

    // Fetch tous les creators au mount
    useEffect(() => {
        const fetchCreators = async () => {
            const { data } = await supabase.rpc('get_public_creators');
            if (data) setCreators(data);
        };
        fetchCreators();
    }, []);

    // Filtrage en temps réel
    useEffect(() => {
        if (!searchQuery.trim()) {
            setSearchResults([]);
            return;
        }
        const q = searchQuery.toLowerCase();
        const results = creators.filter(u => {
            const full = `${u.first_name || ''} ${u.last_name || ''}`.toLowerCase();
            return full.includes(q) || u.username.toLowerCase().includes(q);
        });
        setSearchResults(results);
    }, [searchQuery, creators]);

    const clearSearch = () => {
        setSearchQuery('');
        setSearchResults([]);
    };

    return {
        searchQuery,
        setSearchQuery,
        searchResults,
        clearSearch
    };
}